import { createSlice } from "@reduxjs/toolkit";

const navbarModel = {
  isNavbarOpen: true,
  isNavbarSticky: true,
};

export const navabrSlice = createSlice({
  name: "modal",
  initialState: navbarModel,
  reducers: {
    setIsOpen: (state, action) => {
      return {
        ...state,
        isNavbarOpen: action.payload.isOpen,
      };
    },
    setIsSticky: (state, action) => {
      return {
        ...state,
        isNavbarSticky: action.payload.isSticky,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { setIsOpen, setIsSticky } = navabrSlice.actions;

export default navabrSlice.reducer;
